// place holder for future palette definiions
export default {};
